import _ from 'lodash';

export type CallTimeline = {
  participant: {
    name: string,
    email: string,
  },
  callTime: number,
  questionRatio: CallTimelineParam,
  averagePatience: CallTimelineParam,
  talkingSpeed: CallTimelineParam,
  talkRatio: CallTimelineParam & {
    lowestSuggestedValue: number,
    highestSuggestedValue: number,
  },
  languagePositivity: CallTimelineParam,
  voiceEmotion: CallTimelineParam,
  timeline: {
    start_time: number,
    end_time: number,
  }[]
}

export type CallTimelineParam = {
  status: 'good' | 'average' | 'bad',
  improvementFeedback: string,
  value: number
}

export const getTimelines = (aiAnalysis: {mlDataID: string, mlData: any}[] | undefined): CallTimeline[] | undefined => {
  if (aiAnalysis) {
    const extractData = function<T>(mlDataID: string, mlDataKey: string) {
      const value = aiAnalysis.find(i => i.mlDataID === mlDataID)?.mlData[mlDataKey];
      return _.groupBy<T>(value, 'participantName')
    }

    const timelines = extractData<CallTimeline['timeline'][0]>('meetingTranscript', 'meetingTranscript');
    const callTime = timelines ? Object.values(timelines).reduce(
      (previousValue, currentValue) => currentValue.at(-1)!.end_time > previousValue ? currentValue.at(-1)!.end_time : previousValue, 0
    ) : 0;
    const questionRatio = extractData<CallTimeline['questionRatio']>('languageQuestionRatio', 'data');
    const talkRatio = extractData<CallTimeline['talkRatio']>('languageTalkRatio', 'data');
    const talkingSpeed = extractData<CallTimeline['talkingSpeed']>('languageTalkingSpeed', 'data');
    const averagePatience = extractData<CallTimeline['averagePatience']>('languageAveragePatience', 'data');
    const languagePositivity = extractData<{ data: (CallTimeline['languagePositivity'] & {label: string})[]  }>('languagePositivity', 'averageValues');
    const voiceEmotion = extractData<{ data: (CallTimeline['voiceEmotion'] & {label: string})[]  }>('voiceEmotion', 'averageValues');

    return Object.keys(timelines).map(name => ({
      participant: {
        name, email: name
      },
      questionRatio: questionRatio[name][0],
      talkRatio: talkRatio[name][0],
      talkingSpeed: talkingSpeed[name][0],
      averagePatience: averagePatience[name][0],
      languagePositivity: languagePositivity[name][0].data.find(v => v.label === 'positive')!,
      voiceEmotion: voiceEmotion[name][0].data.find(v => v.label === 'happy')!,
      callTime,
      timeline: timelines[name]
    }));
  }
  return undefined
}
